import React from 'react'
import { ReactFCC } from '@/types/react'

interface RegionContextProps {
  region: string | null
  children: React.ReactNode
}

interface RegionContextType {
  region: string | null
}

const RegionContext = React.createContext<RegionContextType>({
  region: null,
})

export const RegionContextProvider: ReactFCC<RegionContextProps> = ({ children, region }) => {
  return <RegionContext.Provider value={{ region }}>{children}</RegionContext.Provider>
}

export function useRegionContext() {
  return React.useContext(RegionContext)
}
